var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolMillenniumIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "688.000000pt",
    height: "624.000000pt",
    viewBox: "0 0 688.000000 624.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,624.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1026 4508 c5 -7 44 -58 89 -113 45 -55 157 -194 250 -310 93 -115 197 -245 233 -287 l64 -78 379 0 c208 0 379 -2 379 -4 0 -5 -650 -1158 -730 -1296 -139 -240 -261 -464 -257 -474 7 -15 510 -627 513 -623 2 3 390 663 704 1197 485 825 1137 1931 1157 1963 l23 37 -1405 0 c-1122 0 -1405 -3 -1399 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4192 4438 c-46 -77 -206 -348 -442 -748 -53 -91 -156 -264 -227 -385 -72 -121 -206 -348 -298 -505 -92 -157 -242 -411 -333 -564 -138 -235 -163 -282 -153 -297 25 -42 476 -589 484 -589 3 0 31 44 62 97 110 186 1014 1701 1208 2026 l160 267 204 0 c111 0 203 -3 203 -8 0 -4 -6 -16 -14 -27 -7 -11 -75 -128 -151 -260 -248 -433 -406 -707 -503 -875 -279 -482 -362 -630 -362 -639 0 -11 496 -594 509 -599 8 -3 29 33 271 458 139 244 121 212 267 470 61 107 211 371 333 585 123 215 285 500 361 634 l139 245 0 398 0 398 -834 0 -835 0 -49 -82z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolMillenniumIcon);
export default __webpack_public_path__ + "static/media/schoolMillenniumIcon.6fe22fd1de0ee90149e9eb539eb62002.svg";
export { ForwardRef as ReactComponent };